import { Box, Col } from '@opendoor/atoms/box';
import { Link } from '@opendoor/atoms/link';
import { Text } from '@opendoor/atoms/text';

export interface CityLink {
  name: string;
  slug: string;
  count: number;
  state: string;
}

interface CityLinkListProps {
  cities: CityLink[];
}

export const CityLinkList: React.FC<CityLinkListProps> = ({ cities }) => {
  if (!cities.length) {
    return null;
  }

  return (
    <Col as="section" aria-label="Cities with homes for sale" className="flex-1 py-4">
      <Col className="gap-3 px-2">
        <Text as="h2" className="text-subheader-sm">
          Cities with homes for sale
        </Text>
        <Box className="grid gap-4 [grid-template-columns:repeat(auto-fill,minmax(calc(var(--spacing)*62),1fr))]">
          {cities
            .filter((city) => city.count > 0)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((city) => (
              <Box key={city.slug}>
                <Link analyticsName="city-directory-link" href={`/homes/${city.slug}`}>
                  {city.name}, {city.state} ({city.count})
                </Link>
              </Box>
            ))}
        </Box>
      </Col>
    </Col>
  );
};
